import gql from "graphql-tag";

export const VOID_TRANSACTION = gql`
    mutation ($paymentId:Int){
        void_transaction(paymentId:$paymentId)
    }
`